import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";

/**
 * Generated class for the RangeInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "range-input",
  templateUrl: "range-input.html",
})
export class RangeInputComponent implements OnInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  required: boolean;
  max: number;
  min: number;
  step: number;
  snaps: boolean = false;
  value: number;
  disabled: boolean = false;
  readonly: boolean = false;

  constructor(public formBuilder: FormBuilder) {
    // console.log('Hello RangeInputComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Group: ", this.group );
    // console.log( "Slider Input config: ", this.config );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;

    this.group.addControl(this.id, this.formBuilder.control(undefined));

    if (this.readonly) {
      this.group.controls[this.id].disable({ emitEvent: false });
      this.disabled = true;
    }

    var validators = [];
    if (this.config.rules) {
      if (this.config.rules.required) {
        this.required = this.config.rules.required;
        validators.push(Validators.required);
      }

      if (
        this.config.rules.min !== null &&
        this.config.rules.min !== undefined
      ) {
        this.min = this.config.rules.min;
      }

      if (this.config.rules.max) {
        this.max = this.config.rules.max;
      }

      if (this.config.rules.step) {
        this.step = this.config.rules.step;
      }

      if (this.config.rules.snaps) {
        this.snaps = this.config.rules.snaps;
      }
    }

    if (validators.length > 0) {
      let composedValidators: ValidatorFn = Validators.compose(validators);
      // console.log( "Setting validators on control:" );
      // console.log( validators );
      this.group.controls[this.id].setValidators(composedValidators);
    }

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      let selfControl = this.group.controls[this.id];
      // console.log( "Value changed in form: ", data, selfControl.disabled );

      if (data !== undefined && data !== this.value) {
        this.value = data;
      }

      if (this.readonly || selfControl.disabled) {
        selfControl.disable({ emitEvent: false });
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    });

    this.valueChanged(this.group.controls[this.id].value);
  }

  valueChanged(value) {
    // console.log( "Value changed in range: ", value );
    this.group.controls[this.id].setValue(value);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/range-input/range-input.ts